/** The current Seller Terms version: its effective date. It must equal the
 *  gateway's `operators.SellerTermsVersion`; the gateway refuses an acceptance
 *  of any other version, so a seller is only ever recorded against the terms
 *  this page shows. Bumping it re-prompts every seller. */
export const SELLER_TERMS_VERSION = '2026-10-30';

/** The same date as readers see it at the top of the page. */
export const SELLER_TERMS_EFFECTIVE = 'October 30, 2026';

/** True when a seller profile has accepted the current Seller Terms. */
export const hasAcceptedSellerTerms = (profile: { sellerTermsVersion: string }): boolean =>
  profile.sellerTermsVersion === SELLER_TERMS_VERSION;
